import * as React from 'react'

const Success = (props: { className?: string }) => (
  <svg
    className={props.className}
    width='25'
    height='25'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M9 0L3.06921 5.625L0 2.34363' transform='translate(4.5 6.75)' stroke='#666' strokeWidth='2' />
  </svg>
)

export default Success



// WEBPACK FOOTER //
// ./src/components/icons/vehicle/Success.tsx